var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.26743 6.26855C4.46719 6.26855 3.00781 7.72793 3.00781 9.52817L3.00781 11.158L29.0847 11.158V9.52817C29.0847 7.72793 27.6253 6.26855 25.8251 6.26855L6.26743 6.26855Z",
    fill: "#9CA3AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0847 14.4176L3.00781 14.4176L3.00781 22.5666C3.00781 24.3669 4.46719 25.8262 6.26743 25.8262H25.8251C27.6253 25.8262 29.0847 24.3669 29.0847 22.5666V14.4176ZM6.26743 20.9368C6.26743 20.0367 6.99712 19.307 7.89723 19.307H9.52704C10.4272 19.307 11.1568 20.0367 11.1568 20.9368C11.1568 21.8369 10.4272 22.5666 9.52704 22.5666H7.89723C6.99712 22.5666 6.26743 21.8369 6.26743 20.9368ZM14.4165 19.307C13.5163 19.307 12.7867 20.0367 12.7867 20.9368C12.7867 21.8369 13.5163 22.5666 14.4165 22.5666H16.0463C16.9464 22.5666 17.6761 21.8369 17.6761 20.9368C17.6761 20.0367 16.9464 19.307 16.0463 19.307H14.4165Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.678afcde1b85f3d9d463f76cf7498491.svg";
export { ForwardRef as ReactComponent };